import { render, staticRenderFns } from "./detailed.vue?vue&type=template&id=278ef6ed"
import script from "./detailed.vue?vue&type=script&lang=js"
export * from "./detailed.vue?vue&type=script&lang=js"
import style0 from "./detailed.vue?vue&type=style&index=0&id=278ef6ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports